import React from 'react'
import { Box, Container, Grid, Button, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Layout, MyLink } from '../../components'
import { img } from '../../imgs'

export const NotFoundPage: React.FC = (): JSX.Element => {
  const classes = useStyles()

  return (
    <Layout>
      <Box className={classes.page}>
        <Container maxWidth="lg" className={classes.container}>
          <Grid container alignItems="center" justifyContent="center" style={{ height: '80vh' }}>
            <Grid item xs={12}>
              <Grid container justifyContent="center" alignItems="center">
                <Grid item>
                  <img src={img.logoStart} alt="..." className={classes.logo} />
                </Grid>
              </Grid>
              <Box p={6} textAlign="center">
                <Box className={classes.text}>Страница не найдена</Box>
              </Box>
              <Box display="flex" justifyContent="center">
                <Button
                  component={MyLink}
                  className={classes.button}
                  fullWidth
                  variant="contained"
                  color="secondary"
                  to="/"
                >
                  Вернуться на главную
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Layout>
  )
}

const useStyles = makeStyles(({ breakpoints: { down }, palette }: Theme) => ({
  page: {
    height: '100%',
  },
  container: {},
  logo: {
    width: 250,
    height: 'auto',
    position: 'relative',
    [down('sm')]: {
      width: 200,
    },
  },
  text: {
    fontSize: 32,
    fontWeight: 700,
    color: palette.text.primary,
    [down('sm')]: {
      fontSize: 30,
    },
    [down('sm')]: {
      fontSize: 20,
    },
  },
  button: {
    maxWidth: 350,
    fontSize: 18,
    '&:hover': {
      opacity: 0.9,
    },
    [down('sm')]: {
      maxWidth: 300,
      fontSize: 15,
    },
  },
}))
